import { canAccessShiftFloor } from './shiftFloorAccess';

export function getFirstAccessiblePath(currentUser) {
  const perms = currentUser?.effective_permissions || {};
  const has = (key) => !key || perms[key] === true;
  const isTrue = (key) => perms[key] === true;

  // Начальник зміни — одразу на моніторинг цеху
  if (canAccessShiftFloor(currentUser) && currentUser?.oee_role === 'shift_supervisor') {
    return '/shift-floor';
  }
  if (has('menu.dashboard')) return '/';
  if (canAccessShiftFloor(currentUser)) return '/shift-floor';
  if (has('menu.tasks')) return '/tasks';

  const hasPurchaseApprovals = isTrue('menu.purchase_approvals');
  if (hasPurchaseApprovals && !has('menu.purchases')) return '/purchase-approvals';

  if (has('menu.customer_orders')) return '/customer-orders';
  if (has('menu.purchases')) return '/purchases';
  if (isTrue('menu.crm')) return '/crm';

  if (has('menu.production') || has('menu.crushing')) {
    if (has('menu.production.planner')) return '/planner-v2';
    if (has('menu.production.operator')) return '/production-operator-v2';
    if (has('menu.production.warehouse')) return '/production-warehouse';
    if (has('menu.production.work_processes')) return '/work-processes';
    if (has('menu.production.setup')) return '/setup';
    if (has('menu.production.qc_kanban')) return '/qc-kanban';
    if (has('menu.production.qc_stock')) return '/qc-stock-page';
    if (has('menu.production.drying')) return '/production-drying';
    if (has('menu.production.mixing')) return '/production-mixing';
    if (has('menu.crushing')) return '/crushing';
    if (has('menu.production.maintenance')) return '/maintenance-plan';
    if (has('menu.production.products')) return '/products';
    if (has('menu.production.machines')) return '/machines';
    if (has('menu.production.pressforms')) return '/press-forms';
  }

  if (has('menu.packaging')) return '/packaging';
  if (isTrue('menu.packaging_daily_norm')) return '/packaging-daily-norm';
  if (has('menu.stock')) return '/stock';
  if (isTrue('menu.lms') || isTrue('menu.lms.manage')) return '/lms/courses';
  if (isTrue('menu.learning_new') || isTrue('menu.learning_new.manage')) return '/learning/courses';
  if (isTrue('menu.costing')) return '/costing';
  if (isTrue('menu.finance')) return '/finance';
  if (has('menu.leads')) return '/leads';
  if (has('menu.projects')) return '/projects';
  if (has('menu.rnd')) return '/rnd';
  if (has('menu.oee')) return '/oee';
  if (has('menu.activity_log')) return '/activity-log';
  if (has('menu.notification_rules')) return '/notification-rules';
  if (has('menu.process_log')) return '/process-log';
  if (has('menu.bulk_edit')) return '/bulk-edit';

  if (has('menu.settings')) {
    if (has('menu.settings.roles')) return '/settings-roles';
    if (has('menu.settings.staff')) return '/settings-staff';
    if (has('menu.settings.quality')) return '/settings-quality';
    if (has('menu.settings.order_periods')) return '/settings-order-periods';
    if (has('menu.export')) return '/export';
    if (has('menu.import')) return '/import';
  }

  return '/';
}
